export enum RangerFiltersMinAndMax {
  MAX = 'Max',
  CLEAR = 'Clear',
}
